import Vue from 'vue'
import VueI18n from 'vue-i18n'
import en from './en'
import cn from './cn'
import de from './de'
import ja from './ja'
import ko from './ko'
import vi from './vi'

import { Locale } from 'vant'
import enUS from 'vant/lib/locale/lang/en-US'
import zhCN from 'vant/lib/locale/lang/zh-CN'
import deDE from 'vant/lib/locale/lang/de-DE'
import jaJP from 'vant/lib/locale/lang/ja-JP'

Vue.use(VueI18n)

const messages = {
  en: {
    ...enUS,
    ...en
  },
  de: {
    ...deDE,
    ...de
  },
  ja: {
    ...jaJP,
    ...ja
  },
  ko: {
    ...enUS,
    ...ko
  },
  cn: {
    ...zhCN,
    ...cn
  },
  vi: {
    name: 'Tên',
    tel: 'Điện thoại',
    save: 'Đồng ý',
    confirm: 'Xác nhận',
    cancel: 'Hủy bỏ',
    delete: 'Xóa bỏ',
    complete: 'Hoàn thành',
    loading: 'Đang tải...',
    telEmpty: 'Vui lòng điền số điện thoại',
    nameEmpty: 'vui lòng điền tên',
    nameInvalid: 'Vui lòng nhập tên chính xác',
    confirmDelete: 'Bạn có chắc chắn muốn xóa',
    telInvalid: 'Vui lòng nhập số điện thoại chính xác',
    vanCalendar: {
      end: 'Chấm dứt',
      start: 'Bắt đầu',
      title: 'Chọn ngày',
      confirm: 'Đảm bảo',
      startEnd: 'Bắt đầu / Kết thúc',
      weekdays: ['Chủ Nhật', 'Thứ Hai', 'Thứ Ba', 'Thứ Tư', 'Thứ Năm', 'Thứ Sáu', 'Thứ Bảy'],
      monthTitle: (year, month) => `${year} năm ${month} tháng`,
      rangePrompt: (maxRange) => `Các ngày được chọn không được vượt quá ${maxRange} ngày`
    },
    vanCascader: {
      select: 'Xin hãy lựa chọn'
    },
    vanContactCard: {
      addText: 'Thêm địa chỉ liên hệ'
    },
    vanContactList: {
      addText: 'Địa chỉ liên lạc mới'
    },
    vanPagination: {
      prev: 'Trang trước',
      next: 'Trang sau'
    },
    vanPullRefresh: {
      pulling: 'Kéo xuống để làm mới...',
      loosing: 'Phát hành để làm mới...'
    },
    vanSubmitBar: {
      label: 'Toàn bộ:'
    },
    vanCoupon: {
      unlimited: 'Không có ngưỡng sử dụng',
      discount: (discount) => `${discount} Chiết khấu`,
      condition: (condition) => `Có sẵn sau khi chi tiêu ${condition} Việt Nam Đồng`
    },
    vanCouponCell: {
      title: 'Phiếu giảm giá',
      tips: 'Chưa có',
      count: (count) => `${count} trang tính khả dụng`
    },
    vanCouponList: {
      empty: 'Chưa có phiếu giảm giá',
      exchange: 'Trao đổi',
      close: 'Không sử dụng phiếu giảm giá',
      enable: 'Có sẵn',
      disabled: 'không có sẵn',
      placeholder: 'Vui lòng nhập mã khuyến mãi'
    },
    vanAddressEdit: {
      area: 'Khu vực',
      postal: 'Mã bưu điện',
      areaEmpty: 'Vui lòng chọn khu vực',
      addressEmpty: 'Vui lòng điền vào địa chỉ chi tiết',
      postalEmpty: 'Định dạng mã zip không chính xác',
      defaultAddress: 'Đặt làm địa chỉ giao hàng mặc định',
      telPlaceholder: 'Số điện thoại của người nhận hàng',
      namePlaceholder: 'Tên người nhận hàng',
      areaPlaceholder: 'Chọn Tỉnh / Thành phố / Quận / Huyện'
    },
    vanAddressEditDetail: {
      label: 'Địa chỉ chi tiết',
      placeholder: 'Số đường phố, số phòng tầng, v.v.'
    },
    vanAddressList: {
      add: 'Thêm địa chỉ'
    },
    ...vi
  }
}

localStorage.getItem('lang') == null && localStorage.setItem('lang', process.env.VUE_APP_LANG)
const lang = localStorage.getItem('lang')

export const i18n = new VueI18n({
  locale: lang, // 设置默认语言
  fallbackLocale: lang, // 设置备用语言
  messages
})

// 更新vant组件库本身的语言变化，支持国际化
export function vantLocales(lang) {
  if (lang === 'en') {
    Locale.use(lang, enUS)
  } else if (lang === 'cn') {
    Locale.use(lang, zhCN)
  } else if (lang === 'vi') {
    Locale.use(lang, messages.vi)
  } else if (lang === 'de') {
    Locale.use(lang, deDE)
  } else {
    Locale.use(lang, enUS)
  }
}

export default { i18n, vantLocales }
